import { Component } from '@angular/core';

@Component({
  selector: 'icon-route',
  standalone: true,
  // HRS-2513: solid "folded map + centered location pin" glyph (matches the icon Dani attached
  // to the ticket). Filled style (fill = header text color); the pin has a hole via evenodd so
  // the header background shows through.
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
        <!-- folded map: three panels with fold gaps -->
        <path d="M2 14.2 8 12 V20.6 L2 22.8 Z"/>
        <path d="M9 12.4 15 14.2 V22.8 L9 20.8 Z"/>
        <path d="M16 14.2 22 12 V20 L16 22.8 Z"/>
        <!-- location pin (teardrop with a hollow center) -->
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12 1.5c-3.04 0-5.5 2.46-5.5 5.5 0 4.13 5.5 10 5.5 10s5.5-5.87 5.5-10c0-3.04-2.46-5.5-5.5-5.5Zm0 3.4a2.1 2.1 0 1 0 0 4.2 2.1 2.1 0 0 0 0-4.2Z"/>
    </svg>
  `,
  styles: `
    @import '../assets/colors.scss';

    svg{
        cursor: pointer;
        fill: $text_header_color;
    }
  `
})

export class RouteIconComponent {}
